import { useState } from 'react';
import { AccountUser, TimezoneRequest } from 'vopay';
import { api } from '@/services/api.config';

export default function useAccountUsers() {
  const [fetching, setFetching] = useState(false);
  const [users, setUsers] = useState<AccountUser[]>([]);

  async function fetchUsers(params: TimezoneRequest, bearer?: string) {
    try {
      setFetching(true);
      const res = await api.fetchAccountUsers(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setUsers(res.Users);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return {
    fetching,
    users,
    fetchUsers,
  };
}
